var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesNavIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.03454C16.1222 2.77452 18.325 2 20.75 2C23.1764 2 25.3778 2.77452 27 4.03454V25.1431C25.3778 23.8831 23.1764 23.1086 20.75 23.1086C18.325 23.1086 16.1222 23.8831 14.5 25.1431M14.5 4.03454V25.1431V4.03454ZM14.5 4.03454C12.8778 2.77452 10.675 2 8.25 2C5.825 2 3.62222 2.77452 2 4.03454V25.1431C3.62222 23.8831 5.825 23.1086 8.25 23.1086C10.675 23.1086 12.8778 23.8831 14.5 25.1431V4.03454Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesNavIconWhite);
export default __webpack_public_path__ + "static/media/resources_nav_icon_white.a3a5c542536cbdbfaa3180162d313c76.svg";
export { ForwardRef as ReactComponent };